<template>
  <BAutocomplete
    ref="autocomplete"
    v-bind="$attrs"
    item-text="full_name"
    item-value="id"
    label="Пользователь"
    no-data-text="Пользователь не найден"
    :request="request"
    :deactivate-after-input="!excludedRemovable"
    v-on="$listeners"
  >
    <template #item="{ on, item, attrs }">
      <v-list-item :class="attrs.disabled ? 'v-list-item--disabled' : ''" v-on="on">
        <v-list-item-content>
          <v-list-item-title
            class="body-2 font-weight-regular"
            style="white-space: initial;"
            v-text="item.full_name"
          />
          <v-list-item-subtitle
            class="font-weight-regular grey--text text--lighten-1"
            style="white-space: initial;"
            v-text="item.username"
          />
        </v-list-item-content>


        <v-list-item-action v-if="excludedRemovable && attrs.disabled" style="pointer-events: auto !important;">
          <v-tooltip right>
            <template #activator="scope">
              <v-btn
                icon
                color="error"
                small
                v-bind="scope.attrs"
                @click.stop="$emit('action:delete', item)"
                v-on="scope.on"
              >
                <v-icon small>
                  mdi-close
                </v-icon>
              </v-btn>
            </template>
            <span>Удалить</span>
          </v-tooltip>
        </v-list-item-action>
      </v-list-item>
    </template>
  </BAutocomplete>
</template>

<script>
import { openApiMixin } from './mixins'
import { UsersApi } from '@/api/resources'
import { Adapter } from '@/store/createCrudModule'

import BAutocomplete from '../BAutocomplete.vue'


export default {
  name: 'BAutocompleteUser',
  components: {
    BAutocomplete,
  },
  mixins: [
    openApiMixin,
  ],
  props: {
    excludedRemovable: Boolean,
  },
  created() {
    const api = new UsersApi()
    this.adapter = new Adapter(api)
  },
  methods: {
    request(...args) {
      return this.adapter.getAll(...args)
    },
  },
}
</script>
